import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aba4a9d2")

_pushScopeId("data-v-aba4a9d2")
const _hoisted_1 = {
  class: `text-red-lp-100 text-xs md:text-base pt-4`,
  style: {"margin-left":"-30px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: 
      `w-full bg-pink-lp-200 mt-2 rounded-lg flex flex-row ${
        _ctx.isDetail ? 'block-warning-detail' : 'block-warning'
      }`
    
  }, [
    _createVNode("img", {
      src: 
        require(`@/app/ui/assets/svg/${
          _ctx.isDetail ? 'warning-embargo-detail' : 'warning-embargo'
        }.svg`)
      ,
      class: 
        `left-0 ${
          _ctx.isDetail
            ? 'icon-warning-detail top-0'
            : 'icon-warning bottom-0 rounded-l-lg'
        }`
      ,
      alt: ""
    }, null, 10, ["src"]),
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.warning), 1)
  ], 2))
})